import { Panel } from '../panel.class';
import { ReferenceMap } from '../../shared.types';

export type DeletePanelPassthroughParams = {
    panel: Panel;
    refMap: ReferenceMap;
    groupExclusions?: Array<string>;
};

const PASSTHROUGH_SKUS = ['PASSTHROUGH', 'MOK-PASSTHROUGH'];

export const deletePanelPassthrough = (params: DeletePanelPassthroughParams): number => {
	const { panel, groupExclusions = [] } = params;
	let count = 0;

	// Use SKU-based detection since passthrough items have category type 'cutout',
	// not 'passthrough', so category.isPassthrough returns false for both SKU variants
	const hasPassthroughBySku = panel?.panelItemGroups?.children?.some((g) =>
		g.items.children.some((pi) => PASSTHROUGH_SKUS.includes(pi.item.sku))
	) ?? false;

	if (hasPassthroughBySku) {
		panel.panelItemGroups.children.forEach((piGroup) => {
			if (groupExclusions.includes(piGroup.id)) return;

			const hasGroupPassthrough = piGroup.items.children.some((pi) =>
				PASSTHROUGH_SKUS.includes(pi.item.sku)
			);
			if (!hasGroupPassthrough) return;

			// remove existing passthroughs
			for (let i = piGroup.items.children.length - 1; i >= 0; i--) {
				const panelItem = piGroup.items.children[i];
				if (panelItem?.item && PASSTHROUGH_SKUS.includes(panelItem.item.sku)) {
					piGroup.items.delete(panelItem.id);
					count++;
				}
			}
		});
	}

	return count;
};
